import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
{/* LOGOS EN BLANCO 
import LogoMagueySVG from '../../img/comerEleganteLight.png';
import LogoMaguey2SVG from '../../img/comerEleganteVerde.png';
*/}
import { resetDataFC_09 } from '../../redux/DucksBeneficiario/FC_09Ducks'
import { resetDataFC_33 } from '../../redux/DucksBeneficiario/FC_33Ducks'
import { resetDataFC_30 } from '../../redux/DucksBeneficiario/FC_30Ducks'
import { resetDataFC_05 } from '../../redux/DucksBeneficiario/FC_05Ducks'
import { resetDataFC_35 } from '../../redux/DucksBeneficiario/FC_35Ducks'
import { resetDataFC_06 } from '../../redux/DucksBeneficiario/FC_06Ducks'
import { resetDataFC_08 } from '../../redux/DucksBeneficiario/FC_08Ducks'
import { resetDataFC_40 } from '../../redux/DucksBeneficiario/FC_40Ducks'
import { resetDataFC_34 } from '../../redux/DucksBeneficiario/FC_34Ducks'
import { resetDataFC_41 } from '../../redux/DucksBeneficiario/FC_41Ducks'
import { resetDataFC_31 } from '../../redux/DucksBeneficiario/FC_31Ducks'
import { resetDataFC_36 } from '../../redux/DucksBeneficiario/FC_36Ducks'
{/* LOGOS EN NEGRO */ }
import Menu from '../../img/Menu.png';
import RegistroSolicitudes from '../../img/RegistroSolicitudes.png';
import query from '../../img/query.png';
import customer from '../../img/customer.png';
import manager from '../../img/manager.png';
import perfilUser from '../../img/perfilUser.png';
import Holograma from '../../img/Holograma.png'
import Dictamenes from '../../img/dictamenes.png'
import Cartera from '../../img/cartera.png'
import { useDispatch, useSelector } from 'react-redux'
import {
    obtenerSolicitudesWithStatus, obtenerSolicitudesWithStatusProceso,
    Contadorfc_01PorLogin
} from '../../redux/SolicitudesDucks'
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado, obtenerTodasLasSolicitudesWithStatusEnviado, obtenerTodosClientes } from '../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink
} from "react-router-dom";

import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faCheckDouble, faClock,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faPenToSquare, faEdit, faPersonWalking, faRightFromBracket,
    faFilePdf, faAddressCard
} from '@fortawesome/free-solid-svg-icons'
import { obtenerUserPorEmail } from '../../redux/UsuarioDucks';
import CarterasComponent from '../UsuarioAtencionACliente/Carteras/CarterasComponent'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faPenToSquare, faCheckDouble, faClock, faPersonWalking, faRightFromBracket, faAddressCard,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faFilePdf)


const { useState } = React;



const MenuHamburguesaAtencionCliente = (props) => {

    const myRef = useRef(null)
    const myRefMobile = useRef(null)

    const currentUser = useSelector(store => store.Usuario.data)
    const cadenaProductiva = useSelector(store => store.Cliente.cadenaProductiva)
    const contadorSolicitud = useSelector(store => store.Solicitudes.contadorSolicitud)
    const dataUser = useSelector(store => store.Usuario.user)
    const solicitudesStatus = useSelector(store => store.AtencionSolicitud.status)
    const solicitudesStatusBeneficiario = useSelector(store => store.Solicitudes.status)

    const loginIn = localStorage.getItem('user')
    let idUsuario = 0
    let idRol = 0
    let usuario = ''
    if (currentUser) {
        idUsuario = currentUser.user[0].id
        idRol = currentUser.user[0].rol
        usuario = currentUser.user[0].user
    }
    React.useEffect(() => {
        dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
    }, [])

    const pagesATT = ['Nuevas', 'En proceso', 'Devueltas al usuario', 'Recibidas corregidas', 'Aceptadas'];
    const [claseToggle, setclaseToggle] = useState('');
    const [claseNav, setclaseNav] = useState('');
    const [claseBodyPD, setclaseBodyPD] = useState('');
    const [claseHeaderPD, setHeaderPD] = useState('');
    const [overOverFlowDinamico, setOverFlowDinamico] = useState('');
    const [claseDisplay, setclaseDisplay] = useState('none');
    const [claseScrollTop, setScrollTop] = useState('unset');

    const estilos1 = '#c88b3e';
    const estilos0 = '#2b2b2b';

    const [isActiva1ATT, setIsActiva1ATT] = React.useState(estilos0);
    const [isActiva2ATT, setIsActiva2ATT] = React.useState(estilos0);
    const [isActiva3ATT, setIsActiva3ATT] = React.useState(estilos0);
    const [isActiva4ATT, setIsActiva4ATT] = React.useState(estilos0);
    const [isActiva5ATT, setIsActiva5ATT] = React.useState(estilos0);

    const dispatch = useDispatch()
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [activeStep, setActiveStep] = React.useState(0);

    React.useEffect(async () => {
        await activarOpcionMenuATT()
    }, [solicitudesStatus])

    const activarOpcionMenuATT = async () => {
        switch (Number(solicitudesStatus)) {
            case 2:
                setIsActiva1ATT(estilos1);
                setIsActiva2ATT(estilos0);
                setIsActiva3ATT(estilos0);
                setIsActiva4ATT(estilos0);
                setIsActiva5ATT(estilos0);
                break
            case 3:
                setIsActiva1ATT(estilos0);
                setIsActiva2ATT(estilos1);
                setIsActiva3ATT(estilos0);
                setIsActiva4ATT(estilos0);
                setIsActiva5ATT(estilos0);
                break
            case 4:
                setIsActiva1ATT(estilos0);
                setIsActiva2ATT(estilos0);
                setIsActiva3ATT(estilos0);
                setIsActiva4ATT(estilos0);
                setIsActiva5ATT(estilos1);
                break
            case 5:
                setIsActiva1ATT(estilos0);
                setIsActiva2ATT(estilos0);
                setIsActiva3ATT(estilos1);
                setIsActiva4ATT(estilos0);
                setIsActiva5ATT(estilos0);
                break
            case 6:
                setIsActiva1ATT(estilos0);
                setIsActiva2ATT(estilos0);
                setIsActiva3ATT(estilos0);
                setIsActiva4ATT(estilos1);
                setIsActiva5ATT(estilos0);
                break
            default:
                setIsActiva1ATT(estilos0);
                setIsActiva2ATT(estilos0);
                setIsActiva3ATT(estilos0);
                setIsActiva4ATT(estilos0);
                setIsActiva5ATT(estilos0);
                break
        }
    }
    const serviciosConComercamRutasConsulta = [{ text: 'Consulta de Asociados', ruta: '/PanelConsulta', source: query }]

    const serviciosAtencionAClienteAdminRutas = [
        { text: 'Solicitudes', ruta: '/AtencionAClientesComponent', source: RegistroSolicitudes },
        { text: 'Ejecutivos', ruta: '/PanelAtencionACliente', source: customer },
        // { text: 'Carteras', ruta: '/CarterasComponent', source: Cartera },
        { text: 'Administrador de Accesos', ruta: '/PanelBenficiarios', source: manager },
        { text: 'Consulta de Asociados', ruta: '/PanelConsulta', source: query },
        { text: 'Consulta de Hologramas', ruta: '/PanelConsultaHologramasComponent', source: Holograma },
        { text: 'Dictamenes', ruta: '/SolicitudesDictamenesComponent', source: Dictamenes },
    ]

    const serviciosAtencionAClienteEjecutivoRutas = [
        { text: 'Solicitudes', ruta: '/AtencionAClientesComponent', source: RegistroSolicitudes },
        { text: 'Consulta de Asociados', ruta: '/PanelConsulta', source: query },
        { text: 'Consulta de Hologramas', ruta: '/PanelConsultaHologramasComponent', source: Holograma },
        { text: 'Dictamenes', ruta: '/SolicitudesDictamenesComponent', source: Dictamenes }
    ]

    const serviciosDictamen = [
        { text: 'Dictamenes', ruta: '/SolicitudesDictamenesComponent', source: Dictamenes }
    ]
    const limpiarShadows = () => {
        setIsActiva1ATT(estilos0);
        setIsActiva2ATT(estilos0);
        setIsActiva3ATT(estilos0);
        setIsActiva4ATT(estilos0);
        setIsActiva5ATT(estilos0);
    }

    const agregarClasesToggle = async (item) => {
        if (item.text === 'Solicitud de envasado nacional') await dispatch(resetDataFC_33())
        if (item.text === 'Solicitud de exportación') await dispatch(resetDataFC_09())
        if (item.text === 'Traslado de producto') await dispatch(resetDataFC_30())
        if (item.text === 'Uso de marca COMERCAM') await dispatch(resetDataFC_05())
        if (item.text === 'Servicios varios') await dispatch(resetDataFC_35())
        if (item.text === 'Registro de maguey') await dispatch(resetDataFC_06())
        if (item.text === 'Renovación de certificados') await dispatch(resetDataFC_08())
        if (item.text === 'Compra de hologramas') await dispatch(resetDataFC_40())
        if (item.text === 'Suspensión y reactivación') await dispatch(resetDataFC_34())
        if (item.text === 'Solicitud de bebidas con mezcal') await dispatch(resetDataFC_41())
        if (item.text === 'Solicitud de seguimiento') await dispatch(resetDataFC_31())
        if (item.text === 'Solicitud de actualización') await dispatch(resetDataFC_36())
        if (claseBodyPD === '' && claseNav === '' && claseBodyPD === '' && claseHeaderPD === '') {
            setclaseToggle('bx-x');
            setclaseNav('show');
            setclaseBodyPD('body-pd');
            setHeaderPD('body-pd');
            setOverFlowDinamico('scroll');
            setclaseDisplay('contents');
            limpiarShadows();
        }
    }

    const cerrarToggle = async () => {
        setclaseToggle('');
        setclaseNav('');
        setclaseBodyPD('');
        setHeaderPD('');
        setOverFlowDinamico('hidden')
        setclaseDisplay('none');
        limpiarShadows();
    }

    const agregarClasesToggleMobile = () => {
        if (claseBodyPD === '' && claseNav === '' && claseBodyPD === '' && claseHeaderPD === '') {
            setclaseToggle('bx-x');
            setclaseNav('show');
            setclaseBodyPD('body-pd');
            setOverFlowDinamico('scroll');
            setclaseDisplay('contents');
            limpiarShadows();
        }
        else {
            setclaseToggle('');
            setclaseNav('');
            setclaseBodyPD('');
            setHeaderPD('');
            setOverFlowDinamico('hidden')
            setclaseDisplay('none');
            limpiarShadows();
        }
    }

    const handleMenuOptionDeskATT = async (page, index) => {
        setActiveStep(index)
        setAnchorElNav(null);
        let res
        switch (page) {
            case 'Nuevas':
                setIsActiva1ATT(estilos1);
                setIsActiva2ATT(estilos0);
                setIsActiva3ATT(estilos0);
                setIsActiva4ATT(estilos0);
                setIsActiva5ATT(estilos0);
                if (idRol === 1) res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
                else if (idRol === 2) res = await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 2, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
                props.history.push('/AtencionAClientesComponent')
                return
            case 'En proceso':
                setIsActiva1ATT(estilos0);
                setIsActiva2ATT(estilos1);
                setIsActiva3ATT(estilos0);
                setIsActiva4ATT(estilos0);
                setIsActiva5ATT(estilos0);
                if (idRol === 1) res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 3 }))
                else if (idRol === 2) res = await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 3, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
                props.history.push('/AtencionAClientesComponent')
                return
            case 'Devueltas al usuario':
                setIsActiva1ATT(estilos0);
                setIsActiva2ATT(estilos0);
                setIsActiva3ATT(estilos1);
                setIsActiva4ATT(estilos0);
                setIsActiva5ATT(estilos0);
                if (idRol === 1) res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 5 }))
                else if (idRol === 2) res = await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 5, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))

                props.history.push('/AtencionAClientesComponent')
                return
            case 'Recibidas corregidas':
                setIsActiva1ATT(estilos0);
                setIsActiva2ATT(estilos0);
                setIsActiva3ATT(estilos0);
                setIsActiva4ATT(estilos1);
                setIsActiva5ATT(estilos0);
                if (idRol === 1) res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 6 }))
                else if (idRol === 2) res = await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 6, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
                props.history.push('/AtencionAClientesComponent')
                return
            case 'Aceptadas':
                setIsActiva1ATT(estilos0);
                setIsActiva2ATT(estilos0);
                setIsActiva3ATT(estilos0);
                setIsActiva4ATT(estilos0);
                setIsActiva5ATT(estilos1);
                //if (idRol === 1) 
                res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
                //else if (idRol === 2) res = await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
                props.history.push('/AtencionAClientesComponent')
                return
            default:
                if (idRol === 1) res = await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
                else if (idRol === 2) res = await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 2, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
                props.history.push('/AtencionAClientesComponent')
                return
        }
    }

    const catMenu = useRef(null)

    const closeOpenMenus = (e) => {
        if (catMenu.current && !catMenu.current.contains(e.target) && claseBodyPD != '' && claseNav != '' && claseBodyPD != '' && claseHeaderPD != '') {

            cerrarToggle();
        }
    }
    const perfilusuario = () => {
        props.history.push('/perfil_usuario')
    }

    document.addEventListener('mousedown', closeOpenMenus);

    return (
        <Fragment>
            <div style={{ scrollBehavior: claseScrollTop }} className={`body2 scrollbar ${claseBodyPD}`} id='body-pd' >
                <header className={`header ${claseHeaderPD}`} id='header'>
                    <div className='header_toggle' >
                    </div>
                    <div className='text-center'>
                        {(props.idUsuario === 7) &&
                            <button style={{ border: 'none', backgroundColor: '#2b2b2b', color: 'white', fontFamily: 'Montserrat', float: 'left', marginLeft: '-60%' }} onClick={() => { perfilusuario() }} className="botonZoom"> <img src={perfilUser} style={{ width: '25px', transform: 'scale(1.5)' }} /><br />Perfil</button>}
                        {(props.idUsuario === 3) &&
                            <button style={{ border: 'none', backgroundColor: '#2b2b2b', color: 'white', fontFamily: 'Montserrat', float: 'left', marginLeft: '-45%' }} onClick={() => { perfilusuario() }} className="botonZoom"> <img src={perfilUser} style={{ width: '25px', transform: 'scale(1.5)' }} /><br />Perfil</button>}
                        <a ref={catMenu} onClick={agregarClasesToggleMobile} href='#' className='a2 text-center logoEscondido' style={{ color: 'white', width: '30px' }}>
                            <img id="imagenLogoMaguey" className="img-fluid" src={Menu}></img>
                        </a>

                        {props.idUsuario === 3 ? (
                            <Fragment>
                                {idRol === 1 || usuario === 'MONSERRAT LOPEZ' ?
                                    <><span className='text-center textoEscondido'><strong>COMERCAM en línea atención a cliente</strong></span>
                                        <br className='textoEscondido'></br><br></br></>
                                    :
                                    <>{idRol === 2 && usuario !== 'MONSERRAT LOPEZ' ?
                                        <><span className='text-center textoEscondido'><strong>Ejecutiva(o) Atención a clientes</strong></span>
                                            <br className='textoEscondido'></br><br></br></> : ''}</>
                                }

                                <Tooltip title="Nuevas Solicitudes" arrow>
                                    <button style={{ backgroundColor: isActiva1ATT }} onClick={e => handleMenuOptionDeskATT(pagesATT[0], 0)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEraser} /><br /> Nuevas</button>
                                </Tooltip>
                                <Tooltip title="En proceso" arrow>
                                    <button style={{ backgroundColor: isActiva2ATT }} onClick={e => handleMenuOptionDeskATT(pagesATT[1], 1)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEraser} /><br /> En proceso</button>
                                </Tooltip>
                                <Tooltip title="Devueltas al usuario" arrow>
                                    <button style={{ backgroundColor: isActiva3ATT }} onClick={e => handleMenuOptionDeskATT(pagesATT[2], 2)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEraser} /><br /> Devueltas al usuario</button>
                                </Tooltip>
                                <Tooltip title="Recibidas corregidas" arrow>
                                    <button style={{ backgroundColor: isActiva4ATT }} onClick={e => handleMenuOptionDeskATT(pagesATT[3], 3)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEraser} /><br /> Recibidas corregidas</button>
                                </Tooltip>
                                <Tooltip title="Aceptadas" arrow>
                                    <button style={{ backgroundColor: isActiva5ATT }} onClick={e => handleMenuOptionDeskATT(pagesATT[4], 4)} className="badge text-wrap botonZoom botonOpcion">
                                        <FontAwesomeIcon icon={faEraser} /><br />Aceptadas</button>
                                </Tooltip>
                            </Fragment>
                        ) : (<></>)
                        }
                        {
                            props.idUsuario === 7 ? (
                                <Fragment>
                                    <span className='text-center textoEscondido'><strong>COMERCAM en línea consulta</strong></span>
                                    <br className='textoEscondido'></br><br></br>
                                </Fragment>

                            ) : (<></>)
                        }
                    </div>

                    <Tooltip title="Salir de la aplicación" arrow>
                        <button style={{ border: 'none', padding: '4px', backgroundColor: '#2b2b2b', color: 'white', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} onClick={props.cerrarSesionModal} className="text-wrap text-center botonZoom"> <FontAwesomeIcon style={{ transform: 'scale(1.5)' }} icon={faRightFromBracket} /><br />Salir</button>
                    </Tooltip>

                </header>
                <div style={{ overflow: 'scroll' }} className={`l-navbar ${claseNav}`} id='nav-bar'>
                    <nav className='nav'>
                        <div>
                            <a ref={myRef} onClick={agregarClasesToggle} href='#' className='a2 text-center' style={{ color: 'white', width: '30px' }}>

                                <Tooltip title="Abrir el menú de opciones" arrow>
                                    <div className={`bx `} id="header-toggle" style={{ width: '50px', marginTop: '50px; !important', textAlign: 'center', marginLeft: '4%' }}>
                                        <img id="imagenLogoMaguey" className="img-fluid" src={Menu} ></img>
                                    </div>
                                </Tooltip>

                            </a>
                            <div className='nav_list'>
                                <List style={{ backgroundColor: '#2b2b2b', color: 'white' }}>
                                    {(props.idUsuario === 3 && idRol === 1) ?
                                        <Fragment >
                                            {serviciosAtencionAClienteAdminRutas.map((item, index) => (

                                                <NavLink key={index} exact to={item.ruta} className="nav_link" onClick={cerrarToggle}>
                                                    <Tooltip key={index} title={serviciosAtencionAClienteAdminRutas[index].text} arrow>
                                                        <img src={serviciosAtencionAClienteAdminRutas[index].source} style={{ width: '45px', backgroundImage: '#CD973D' }} />
                                                    </Tooltip>
                                                    <span className="nav_name text-wrap">{item.text}</span>
                                                </NavLink>

                                            ))}
                                        </Fragment>
                                        : (props.idUsuario === 3 && idRol === 2) ?
                                            <Fragment >
                                                {serviciosAtencionAClienteEjecutivoRutas.map((item, index) => (

                                                    <NavLink key={index} exact to={item.ruta} className="nav_link" onClick={cerrarToggle}>
                                                        <Tooltip key={index} title={serviciosAtencionAClienteEjecutivoRutas[index].text} arrow>
                                                            <img src={serviciosAtencionAClienteEjecutivoRutas[index].source} style={{ width: '45px' }} />
                                                        </Tooltip>
                                                        <span className="nav_name text-wrap">{item.text}</span>
                                                    </NavLink>

                                                ))}
                                            </Fragment>
                                            : (props.idUsuario === 3 && idRol === 3) ?
                                                <Fragment >
                                                    {serviciosDictamen.map((item, index) => (

                                                        <NavLink key={index} exact to={item.ruta} className="nav_link" onClick={cerrarToggle}>
                                                            <Tooltip key={index} title={serviciosDictamen[index].text} arrow>
                                                                <img src={serviciosDictamen[index].source} style={{ width: '45px' }} />
                                                            </Tooltip>
                                                            <span className="nav_name text-wrap">{item.text}</span>
                                                        </NavLink>

                                                    ))}
                                                </Fragment>
                                                : (props.idUsuario === 7) ?
                                                    <Fragment >
                                                        {serviciosConComercamRutasConsulta.map((item, index) => (

                                                            <NavLink key={index} exact to={item.ruta} className="nav_link" onClick={agregarClasesToggle}>
                                                                <Tooltip key={index} title={serviciosConComercamRutasConsulta[index].text} arrow>
                                                                    <img src={serviciosConComercamRutasConsulta[index].source} style={{ width: '45px', backgroundImage: '#CD973D' }} />
                                                                </Tooltip>
                                                                <span className="nav_name text-wrap">{item.text}</span>
                                                            </NavLink>

                                                        ))}
                                                    </Fragment>
                                                    :
                                                    <></>
                                    }
                                </List>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>

            {props.componenteCerrarSesionModal}
        </Fragment>
    );
};
export default withRouter(MenuHamburguesaAtencionCliente)